module.exports = __webpack_public_path__ + "img/home-part-d.7fed0ef1.png";